// extracted by mini-css-extract-plugin
export default {"Globe":"Globe_Globe__VT6BI"};